import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { RatesApiAdapter } from '@modules/Rates/adapters/RatesApiAdapter';
import { Rate } from '@modules/Rates/models/rate.types';

async function fetchAllActiveRates(): Promise<Rate[]> {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new RatesApiAdapter(httpClient);

  const allRates: Rate[] = [];
  let page = 1;
  let hasMore = true;

  while (hasMore) {
    const response = await adapter.getRatesPaginated({
      is_active: true,
      page,
      per_page: 100,
    });

    allRates.push(...response.rates);

    hasMore = response.hasMore;
    if (response.nextPage) {
      page = response.nextPage;
    } else {
      hasMore = false;
    }
  }

  return allRates;
}

export const useActiveRates = (enabled = true) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['activeRates'],
    queryFn: fetchAllActiveRates,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return {
    activeRates: data ?? [],
    isLoading,
    error,
    refetch,
  };
};
